import { PageTitle } from '_metronic/layout/core'

import ButtonFilter from 'Presentation/Components/ButtonFilter'
import CustomListFilter from './Components/CustomListFilter'
import ProductTable from './Components/ProductTable'
import ProductBox from './Components/ProductBox'

import useViewModel from './ViewModel'

//////////
// View //
//////////

const ProductsListView = () => {
	const { filters, data, viewType, changeViewType, newProduct } = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				{/* Button Filter */}
				<div className="d-none d-xl-block col-xl-10">
					<ButtonFilter buttons={filters} />
				</div>
				<div className="col-12 col-xl-2 text-xl-end">
					<button
						className="btn btn-sm btn-kumopack-secondary-600 text-kumopack-base-white fw-bold"
						onClick={newProduct}>
						เพิ่มสินค้าใหม่
					</button>
				</div>
				<div className="d-none d-xl-block col-12">
					<div className="separator border-kumopack-grey-200" />
				</div>

				{/* List Filter */}
				<div className="col-12">
					<CustomListFilter viewType={viewType} changeViewType={changeViewType} />
				</div>

				{/* begin:: Table */}
				<div className="col-12 col-xl-12">
					<div className="card border border-kumopack-grey-200">
						{viewType === 'table' ? (
							<ProductTable products={data} />
						) : (
							<ProductBox products={data} />
						)}
					</div>
				</div>
				{/* End:: Table */}
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Products',
						path: '/products',
						isActive: false,
						isSeparator: false,
						customIcon: (
							<img
								className="me-2"
								src="/media/kumopack-sidebar-icons/Profile.png"
								alt="Breadcrumbs Page Custom Icon"
								width={16}
								height={16}
							/>
						),
					},
					{
						title: 'All Product',
						path: '/products/all-product',
						isActive: true,
						isSeparator: false,
					},
				]}>
				All Products
			</PageTitle>

			{children}
		</>
	)
}

export default ProductsListView
